import { jsx as _jsx } from "react/jsx-runtime";
import { SkeletonInfo } from '../skeleton';
import s from './token-selector-skeleton.module.scss';
export const TokenSelectorSkeleton = () => (_jsx("div", { className: s.loader, children: _jsx(SkeletonInfo, { height: "60" }) }));
